import type { Eta } from '../eta/eta.interface';
import { ETA_ANCHOR_KIND, ETA_FRESHNESS } from '../eta/eta.interface';
import { VEHICLE_PROFILES } from '../vehicle-template/vehicle-template.interface';
import { ObjectFactory } from './object.factory';

export class EtaFactory extends ObjectFactory<Eta> {
  protected getDefaults(): Eta {
    return {
      anchor: {
        departureTime: new Date('2026-05-22T08:00:00'),
        kind: ETA_ANCHOR_KIND.LAST_POSITION,
        position: { latitude: 0, longitude: 0 },
      },
      computedAt: new Date('2026-05-22T09:00:00'),
      requestedAt: new Date('2026-05-22T09:00:00'),
      state: ETA_FRESHNESS.APPROXIMATE,
      value: new Date('2026-05-22T15:30:00'),
      vehicleProfile: { profile: VEHICLE_PROFILES.LIGHTWEIGHT_VEHICLE },
    };
  }
}

export const etaFactory = new EtaFactory();
